// This file was separated out to avoid circular dependencies

export const isMSXUrl = () => window.location.host.includes('crm.dynamics.com');

export const isMSXInTeams = () =>
	window.location.ancestorOrigins.contains('https://teams.microsoft.com');
